import {
  AfterViewInit,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';

import {
  ChessboardFun,
  chessBoard,
  gameIsnotRated,
  makeApiCall,
  puzzlecurrentRating,
  response,
} from '../../shared/functions/chessboardMain';
import { Route, Router, RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';
import { game } from '../../shared/functions/chess';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { PuzzleService } from '../../shared/services/puzzle.service';
import {
  highlightLastMove,
  highlightNextMove,
  puzzleMoveLength,
  puzzlesolved,
  resetChess,
  updateBoard,
} from '../../shared/functions/onDrop';
import { ProfileService } from '../../shared/services/profile.service';
import { Chess } from '../../shared/js';
import { ToastrService } from 'ngx-toastr';
import { DecryptionService } from '../../shared/services/decryption.service';
import { LoginPopupComponent } from '../../shared/login-popup/login-popup.component';
@Component({
  selector: 'app-puzzle',
  standalone: true,
  templateUrl: './puzzle.component.html',
  styleUrl: './puzzle.component.scss',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    RouterModule,
    LoginPopupComponent,
  ],
})
export class PuzzleComponent implements OnInit, AfterViewInit {
  selectedOptions: string[] = [];
  protected puzzleOption!: FormGroup;
  selectedpuzzle: any;
  puzzleMenu = true;
  loading!: boolean;
  nextpuzzlebtn = false;
  PuzzleBoard: boolean = false;
  puzzlesfinishdata!: any;
  allpuzzlefinish: boolean = false;
  normalPuzzle: boolean = false;
  dailyPuzzleShow: boolean = true;
  themeIndex: any;
  puzzleMove: any;
  themes: any;
  puzzleRatingData: any;
  puzzleRatingShow = false;
  chessboard: any;
  game = new Chess();
  chessBoardShow: boolean = false;
  currentpuzzlerating!: any;
  withoutLoginPuzzle: any[] = [];
  showAdvancedOptions: boolean = false;
  puzzlesolvedText: string = '';
  ratedNextpuzzle!: boolean;
  nextPuzzleBtn = false;
  errorMessage!: string;
  custompuzzle: boolean = false;
  modalDisplayStyle!: boolean;

  constructor(
    private fb: FormBuilder,
    private PuzzleData: PuzzleService,
    private ratingData: ProfileService,
    private router: Router,
    private toastr: ToastrService,
    private decryptionApi: DecryptionService
  ) {}

  ngOnInit(): void {
    if (game.isGameOver() == true) {
      this.nextpuzzlebtn = true;
    }
    this.puzzleOption = this.fb.group(
      {
        TacticalThemes: ['Tactical Themes'],
        Mate: ['Mate'],
        EndgameTactics: ['Endgame Tactics'],
        OpeningTactics: ['Opening Tactics'],
        MatingPatterns: ['Mating Patterns'],
        StrategicThemes: ['Strategic Themes'],
        SpecialMoves: ['Special Moves'],
        minRating: [''],
        maxRating: [''],
      },
      { validators: this.ratingRangeValidator }
    );

    let dailyPuzzleSection: any = localStorage.getItem('dailyPuzzleFinish');
    if (dailyPuzzleSection == 'true') {
      this.dailyPuzzleShow = false;
    }
    if (!this.chessBoardShow) {
      // this.chessboard = ChessBoard('hijk', 'start');
      // this.makeRandomMove();
      // resizeRandomMovesChessboard(this.chessboard);
    }

    puzzlecurrentRating.subscribe((res) => {
      this.currentpuzzlerating = res - this.puzzleRatingData;
    });

    puzzlesolved.subscribe({
      next: (res) => {
        if (res === true) {
          this.puzzlesolvedText = 'Puzzle solved.';
          this.nextPuzzleBtn = true;
        } else {
          this.puzzlesolvedText = '';
          this.nextPuzzleBtn = false;
        }
      },
    });
  }

  ngAfterViewInit(): void {
    ChessboardFun();
  }

  ngOnDestroy(): void {
    chessBoard.destroy();
  }

  isNaN(value: any): boolean {
    return isNaN(value);
  }

  nextPuzzle() {
    this.puzzlesfinishdata = response;
    if (this.puzzlesfinishdata == null) {
      this.allpuzzlefinish = true;
    }
    this.puzzleData();
    $('#puzzlemove').show();
    $('#puzzleHit').show();
  }

  nextratedPuzzle() {
    this.currentpuzzlerating = null;
    this.puzzlesfinishdata = response;
    if (this.puzzlesfinishdata == null) {
      this.allpuzzlefinish = true;
    }
    $('#puzzlemove').show();
    $('#puzzleHit').show();
    this.ratingpuzzleMode();
  }

  toggleAdvancedOptions(): void {
    this.showAdvancedOptions = !this.showAdvancedOptions;
  }

  ratingRangeValidator(group: FormGroup) {
    const minRating = group.get('minRating')?.value;
    const maxRating = group.get('maxRating')?.value;

    if (minRating === null && maxRating === null) {
      return { ratingRangeRequired: true };
    }

    if (minRating === null || maxRating === null) {
      return { ratingRangeInvalid: true };
    }

    return minRating <= maxRating ? null : { ratingRangeInvalid: true };
  }

  puzzleMainroute() {
    $('#puzzleHit').show();
    puzzleMoveLength(0);
    this.allpuzzlefinish = false;
    this.puzzleRatingShow = false;

    this.chessBoardShow = false;
    this.puzzleMenu = this.normalPuzzle || !this.nextpuzzlebtn;
    this.nextpuzzlebtn = false;
    this.PuzzleBoard = false;
    // this.puzzleCountdata();
    if (game.turn() == 'b') {
      chessBoard.orientation('white');
    } else {
      chessBoard.orientation('black');
    }
    makeApiCall(null);
    highlightLastMove();
    updateBoard();
    resetChess();
  }

  makeRandomMove() {
    var possibleMoves = this.game.moves();
    if (this.game.isGameOver()) {
      this.chessboard.start();
      this.game.reset();
    }
    var randomIdx = Math.floor(Math.random() * possibleMoves.length);
    this.game.move(possibleMoves[randomIdx]);
    this.chessboard.position(this.game.fen());
    if (!this.chessBoardShow) {
      setTimeout(() => {
        this.makeRandomMove();
      }, 800);
    }
  }

  onCustomerChanged(event: any) {
    if (this.selectedOptions.length == 2) {
      this.puzzleOption.disable();
    }

    if (this.selectedOptions.length < 3) {
      this.selectedOptions.push(event.target.value);
    }
  }

  removeSelectoption(index: any) {
    this.puzzleOption.controls['TacticalThemes'].setValue('Tactical Themes');
    this.puzzleOption.controls['Mate'].setValue('Mate');
    this.puzzleOption.controls['EndgameTactics'].setValue('Endgame Tactics');
    this.puzzleOption.controls['OpeningTactics'].setValue('Opening Tactics');
    this.puzzleOption.controls['MatingPatterns'].setValue('Mating Patterns');
    this.puzzleOption.controls['StrategicThemes'].setValue('Strategic Themes');
    this.puzzleOption.controls['SpecialMoves'].setValue('Special Moves');
    if (this.selectedOptions.length <= 3) {
      this.puzzleOption.enable();
    }
    this.selectedOptions.splice(index, 1);
  }

  PuzzleHit() {
    highlightNextMove();
  }

  puzzleStartGame() {
    this.chessBoardShow = true;
    this.selectedOptions = [];
    this.normalPuzzle = true;
    this.puzzleMenu = false;
    this.PuzzleBoard = true;
    this.nextpuzzlebtn = true;
    this.puzzleRatingShow = true;
    this.ratingpuzzleMode();
  }

  puzzlemode() {
    const UserId = localStorage.getItem('loggedInUser');
    if (UserId !== null) {
      this.modalDisplayStyle = false;
      this.puzzleRatingShow = false;
      this.puzzleMenu = false;
      this.nextpuzzlebtn = false;
      this.custompuzzle = true;
      this.normalPuzzle = true;
    } else {
      this.modalDisplayStyle = true;
    }
  }

  puzzleData() {
    this.selectedpuzzle = '';
    this.loading = true;
    let themeData: any;
    this.ratedNextpuzzle = false;
    const minRating = this.puzzleOption.get('minRating')?.value;
    const maxRating = this.puzzleOption.get('maxRating')?.value;
    if (this.selectedOptions.length > 0) {
      themeData = {
        themes: this.selectedOptions,
        maxRating: maxRating,
        minRating: minRating,
      };
      this.puzzleRatingShow = false;
    } else {
      themeData = {
        maxRating: maxRating,
        minRating: minRating,
      };
    }
    gameIsnotRated({ rated: false });
    $('#finishAllPuzzle').hide();

    this.PuzzleData.puzzleGetData(themeData).subscribe({
      next: (res: any) => {
        const decrypt = this.decryptionApi.decrypt(res.payload);
        const jsondecrpt = JSON.parse(decrypt);
        this.loading = false;
        if (jsondecrpt && Object.keys(jsondecrpt).length === 0) {
          this.PuzzleBoard = false;
          this.selectedpuzzle = 'Not Available Puzzles.';
        } else {
          this.PuzzleBoard = true;
          this.chessBoardShow = true;
          this.nextpuzzlebtn = true;
          this.themeIndex = jsondecrpt;
          this.puzzleMove = this.themeIndex.Moves.split(' ');
          this.themes = this.themeIndex.Themes.split(' ');
          makeApiCall(jsondecrpt);
        }
      },
    });
  }

  ratingpuzzleMode() {
    this.puzzleRating();
    this.ratedNextpuzzle = true;
    this.currentpuzzlerating = null;
    gameIsnotRated({ rated: true });
    let login = localStorage.getItem('loggedInUser');
    if (login) {
      this.PuzzleData.puzzleGetData('').subscribe({
        next: (res: any) => {
          const decrypt = this.decryptionApi.decrypt(res.payload);
          const jsondecrpt = JSON.parse(decrypt);
          if (jsondecrpt && Object.keys(jsondecrpt).length === 0) {
            this.PuzzleBoard = false;
            this.puzzleMenu = true;
            updateBoard();
            resetChess();

            this.toastr.error(res.messages);
          } else {
            this.PuzzleBoard = true;
            this.chessBoardShow = true;
            this.nextpuzzlebtn = true;
            this.themeIndex = jsondecrpt;
            this.puzzleMove = this.themeIndex.Moves.split(' ');
            this.themes = this.themeIndex.Themes.split(' ');
            makeApiCall(jsondecrpt);
          }
        },
      });
    } else {
      this.PuzzleData.puzzleGetData({
        playedPuzzles: this.withoutLoginPuzzle,
      }).subscribe({
        next: (res: any) => {
          const decrypt = this.decryptionApi.decrypt(res.payload);
          const jsondecrpt = JSON.parse(decrypt);
          this.PuzzleBoard = jsondecrpt !== '';

          this.withoutLoginPuzzle.push(jsondecrpt.Index);
          this.themeIndex = jsondecrpt;
          this.puzzleMove = this.themeIndex.Moves.split(' ');
          this.themes = this.themeIndex.Themes.split(' ');
          makeApiCall(jsondecrpt);
        },
        error: (err) => {
          this.PuzzleBoard = false;
          this.puzzleMenu = true;
          resetChess();
          updateBoard();
          this.toastr.error(err.error.message);
        },
      });
    }
  }

  puzzleRating() {
    let login = localStorage.getItem('loggedInUser');
    if (login) {
      this.ratingData.playerRating().subscribe({
        next: (res) => {
          const decrypt = this.decryptionApi.decrypt(res.payload);
          const jsondecrpt = JSON.parse(decrypt);
          this.puzzleRatingData = jsondecrpt.ratings.puzzle.last.rating;
        },
      });
    }
  }

  GetChildData(data: any) {
    this.modalDisplayStyle = data;
  }

  dailyPuzzle() {
    let login = localStorage.getItem('loggedInUser');
    if (login !== null) {
      this.modalDisplayStyle = false;
      this.router.navigate(['puzzle/dailypuzzle']);
    } else {
      this.modalDisplayStyle = true;
    }
  }
}
